module.exports = __webpack_public_path__ + "img/hr-V-R-135-unload-standup-top.89d3aeed.png";